import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRoomSystemScheduledSessions } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getRoomSystemScheduledSessions = async ({
  from,
  to,
  organisationId,
  roomSystemId,
}: {
  from: string;
  to: string;
  organisationId?: string;
  roomSystemId?: string;
}): Promise<PublicRoomSystemScheduledSessions[]> => {
  const response = await axiosClient.get(
    `/analytics/room-system-scheduled-sessions`,
    {
      params: {
        from,
        to,
        organisationId,
        roomSystemId,
      },
    },
  );
  return response.data;
};

export function getRoomSystemScheduledSessionsQueryKey(
  from: string,
  to: string,
  organisationId?: string,
  roomSystemId?: string,
) {
  return [
    "room-system-scheduled-sessions-analytics",
    from,
    to,
    organisationId,
    roomSystemId,
  ];
}

export function useGetRoomSystemScheduledSessions(
  {
    from,
    to,
    organisationId,
    roomSystemId,
  }: {
    from: string;
    to: string;
    organisationId?: string;
    roomSystemId?: string;
  },
  queryOptions?: Partial<
    UseQueryOptions<PublicRoomSystemScheduledSessions[], HttpError>
  >,
) {
  return useQuery({
    queryKey: getRoomSystemScheduledSessionsQueryKey(
      from,
      to,
      organisationId,
      roomSystemId,
    ),
    queryFn: () =>
      getRoomSystemScheduledSessions({
        from,
        to,
        organisationId,
        roomSystemId,
      }),
    ...queryOptions,
  });
}
